<div class="container-fluid">
  <div class="d-flex flex-row align-items-center justify-content-between main-header">
    <div class="d-flex align-items-center">
      <app-bar-menu
        [open]="menuOpen"
        (toggleEvent)="toggleMenu()"
        *ngIf="isLoggedIn$ | async"
      ></app-bar-menu>
      <h3 class="ms-5 mb-0 text-white">Svebar</h3>
    </div>
    <div *ngIf="(globalStateService.csvDownloadInProgress | async)" class="download-in-progress"> <i class="fa-solid fa-spinner fa-spin"></i> Pågående nedladdning av CSV-fil</div>
  </div>
  <div class="mt-3 d-flex">
    <ng-container *ngIf="(isLoggedIn$ | async) && menuOpen">
      <panel-menu></panel-menu>
    </ng-container>
    <div class="full-width">
      <p-toast position="center" styleClass="standard-name-toast"></p-toast>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
